import select2 from 'select2/dist/js/select2.full'
export default function accountCtrl($scope, $http, $rootScope, $compile) {
    
    $scope.validationOptions = {
        rules: {
            email: {
                required: true,
                email: true
            },
            password:{
                required: true,
            },
            password_confirmation:{
                required: true,
            }
        },
        messages: {
            bill_code: {
                required: "required"
            },
            ship_code: {
                required: "required"
            },
        },
        ignore: [],
        errorPlacement: function (error, element) {
            if ($(element).is(":radio")) {
                var hidELement = $(element).parent().parent().parent();
                error.appendTo(hidELement);

            } else if ($(element).is("select")) {

                var hidELement = $(element).parent().find('span.select2.select2-container');
                error.insertAfter(hidELement);

            } else if ($(element).is(":hidden")) {
                var hidELement = $(element).parent();
                error.insertAfter(hidELement);
            } else {
                error.insertAfter(element);
            }
        },
        highlight: function (element, errorClass, validClass) {
            if ($(element).is(":hidden")) {
                $(element)
                    .parent()
                    .addClass(errorClass)
                    .removeClass(validClass);
            } else {
                $(element)
                    .addClass(errorClass)
                    .removeClass(validClass);

                $(element)
                    .prev()
                    .addClass('top-error');

                $(element)
                    .parent()
                    .addClass('error')
            }
        },
        unhighlight: function (element, errorClass, validClass) {

            if ($(element).is(":hidden")) {
                $(element)
                    .parent()
                    .removeClass(errorClass)
                    .addClass(validClass);
            } else {
                $(element)
                    .removeClass(errorClass)
                    .addClass(validClass);

                $(element)
                    .prev()
                    .removeClass('top-error');

                $(element)
                    .parent()
                    .removeClass('error')
            }
        }
    };

    $scope.submitForm = function(event){

        
        if (!$scope.resetFormName.validate()) {
            event.preventDefault();
        }
        // $scope.resetFormName.validate();

        // if (!$scope.resetFormName.validate()) {
        //     event.preventDefault();
        // }
        // event.preventDefault();
    }
}

accountCtrl.$inject = ['$scope', '$http', '$rootScope', '$compile']